module.exports = __webpack_public_path__ + "static/media/save.0f4061b2.svg";